
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {bus} from "@/plugins/bus";
  import {IBus} from "@/interfaces/bus-actions";
  import {IApp} from "@/interfaces/app.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({})
  export default class BalanceMenuButton extends Vue {

    @Prop() colorMode: boolean;

    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get balance() { return this.userAccess.balance; }
    get displayBalance() {
      let result = true;
      const blackList = [ IApp.ROUTE_NAME.PAGE_REGISTRATION, ];
      const notInBlackList = !blackList.includes(this.$route.name as IApp.ROUTE_NAME);
      result = notInBlackList && !this.userAccess.disableBalance;
      return result;
    }

    async openPopup() {
      bus.$emit(IBus.AppMenuAction.Close);
      await this.$store.dispatch('dialog/openDialog', { blockName: 'payment', dialogName: 'balancePopup' });
    }
  }
